import { RAW_COLORS } from '../../../foundation/colors';

export const theme = {
  color: {
    bg: {
      normal: RAW_COLORS.white,
      disabled: RAW_COLORS.bluegray100,
    },
    border: {
      normal: RAW_COLORS.bluegray200,
      active: RAW_COLORS.blue700,
      error: RAW_COLORS.red600,
      hover: RAW_COLORS.bluegray300,
      disabled: RAW_COLORS.bluegray200,
      'focus-effect': RAW_COLORS.blue200,
      'error-focus-effect': RAW_COLORS.red100,
    },
    button: {
      normal: RAW_COLORS.blue700,
      disabled: RAW_COLORS.blue300,
      error: RAW_COLORS.red600,
      'error-disabled': RAW_COLORS.red300,
    },
  },
  size: {
    small: {
      height: '28px',
      maxWidth: '200px',
      mainLabelSize: 's',
      subLabelSize: 'xs',
      typographySize: 's',
      fontSize: '13px',
      buttonFontSize: '13px',
      paddingX: '7px',
      paddingY: '3.25px',
      gap: '4px',
      buttonPadding: '8px',
      chipSize: 'small',
      iconSize: 16,
    },
    medium: {
      height: '32px',
      maxWidth: '280px',
      mainLabelSize: 'm',
      subLabelSize: 's',
      typographySize: 'm',
      fontSize: '14px',
      buttonFontSize: '14px',
      paddingX: '11px',
      paddingY: '4.5px',
      gap: '4px',
      buttonPadding: '12px',
      chipSize: 'small',
      iconSize: 16,
    },
    large: {
      height: '38px',
      maxWidth: '286px',
      mainLabelSize: 'l',
      subLabelSize: 'm',
      typographySize: 'l',
      fontSize: '16px',
      buttonFontSize: '16px',
      paddingX: '13px',
      paddingY: '6px',
      gap: '8px',
      buttonPadding: '14px',
      chipSize: 'medium',
      iconSize: 20,
    },
  },
  transitionTiming: '225ms',
} as const;
